import m from "../../../../geodata/es2015/region/usa/orHigh";
window.am4geodata_region_usa_orHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/orHigh.js
// module id = null
// module chunks = 